import { Rect } from '../../../platform/geom/Rect';
import { TextSettings } from '../../canvas/entities/TextConventions';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { Textbox } from './Textbox';

const valueLayout = (textbox: Textbox, area: Rect) => {

    const baseSettings = TextSettings.from({
        ...TextSettings.default,
        fontColor: textbox.fontColor,
        fontFamily: textbox.fontFamily,
        fontSize: textbox.fontSize,
        textAlignH: textbox.textAlignH,
        textAlignV: textbox.textAlignV,
        textMargin: [5, 10],
    });

    const fontSize = Math.min(
        baseSettings.fontSize,
        (TextRuler.fit(textbox.value, baseSettings, area.width, area.height)),
    );

    return {
        bounds: area,
        settings: { ...baseSettings, fontSize },
    };
};

export const TextboxLayout = (textbox: Textbox) => {

    const base = new Rect(0, 0, textbox.width, textbox.height);

    const value = valueLayout(textbox, base);

    return Object.freeze({
        base,
        background: textbox.background,
        value,
    });
};

export type TextboxLayout = ReturnType<typeof TextboxLayout>;
